import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconSlowTurns = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="#fff"
      d="m15.73 7.08-5.5 4.719c-.468.406-1.218.062-1.218-.563V8.517C4.137 8.58 2.074 9.767 3.48 14.3c.157.5-.468.906-.875.593-1.375-1-2.593-2.906-2.593-4.812 0-4.75 3.968-5.782 9-5.844V1.767c0-.656.75-1 1.218-.593l5.5 4.718c.344.344.344.875 0 1.188Z"
    />
  </svg>
));
export default SvgIconSlowTurns;
